<template>
    <div>
        <div v-if="isShow">
            <div class="select">
                <!-- 课程名称 -->
                <span>课程名称：</span>
                <input type="text" v-model="className" class="className" />
                <!-- 建课老师 -->
                <span>建课老师：</span>
                <el-select
                    v-model="teacher"
                    placeholder="请选择"
                    class="teacher"
                    size="mini"
                >
                    <el-option
                        v-for="item in teachers"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <!-- 选择机构 -->
                <span>选择机构：</span>
                <el-select
                    v-model="organ"
                    placeholder="请选择"
                    class="organ"
                    size="mini"
                >
                    <el-option
                        v-for="item in organs"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <hr />
            <div class="btn">
                <button
                    style="background-color: #409eff; border: 0; color: #fff"
                >
                    确认
                </button>
                <button @click="isShow = false">收起</button>
                <button>清空</button>
            </div>
        </div>
        <div class="selectbtn">
            <button @click="isShow = true">筛选</button>
            <button>导出结果</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShow: false,
            first: true,
            // 机构
            organs: [
                {
                    value: "-不限机构-",
                },
            ],
            organ: "-不限机构-",
            // 时间
            teachers: [
                {
                    value: "-全部-",
                },
                {
                    value: "李老师",
                },
                {
                    value: "周老师",
                },
                {
                    value: "张老师",
                },
            ],
            teacher: "-全部-",
            className: "",
        };
    },
};
</script>

<style lang="scss" scoped>
.select {
    font-size: 16px;
    height: 30px;
    margin: 20px 0 10px;
    padding-left: 30px;
}
.className {
    margin-right: 62px;
    border: 1px solid #000;
}
.organ {
    width: 206px;
    height: 32px;
    border-radius: 5px;
}
.teacher {
    width: 206px;
    height: 32px;
    border-radius: 5px;
    margin-right: 62px;
}

input {
    display: inline-block;
    width: 206px;
    height: 32px;
    border-radius: 5px;
}
.btn {
    text-align: center;
}
button {
    width: 73px;
    height: 28px;
    border: 1px solid #000;
    border-radius: 5px;
    margin: 0 20px;
}
.selectbtn {
    margin: 10px 0;
    background-color: #f2f2f2;
}
button {
    width: 73px;
    height: 28px;
    border-radius: 5px;
    margin: 0 20px;
    background-color: #409eff;
    border: 0;
    color: #fff;
}
</style>